<template>
  <b-row>
    <b-col
      xs="12"
      md="8"
    >
      <b-card>
        <b-card-title>Genel Bilgi</b-card-title>
        <b-row>
          <b-col>
            <b-form-group label="Adı">
              <b-form-input
                v-model="formData.name"
                placeholder="Adı"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Soyadı">
              <b-form-input
                v-model="formData.surname"
                placeholder="Soyadı"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="E-Posta (İş)">
              <b-form-input
                v-model="formData.email_business"
                placeholder="E-Posta (İş)"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="E-Posta (Kişisel)">
              <b-form-input
                v-model="formData.email_personal"
                placeholder="E-Posta (Kişisel)"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Telefon (İş)">
              <b-input-group>
                <b-input-group-prepend is-text>
                  TR (+90)
                </b-input-group-prepend>
                <cleave
                  id="phone_business"
                  v-model="formData.phone_business"
                  class="form-control"
                  :raw="false"
                  :options="options.phone"
                  placeholder="Telefon (İş)"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Telefon (Kişisel)">
              <b-input-group>
                <b-input-group-prepend is-text>
                  TR (+90)
                </b-input-group-prepend>
                <cleave
                  id="phone_personal"
                  v-model="formData.phone_personal"
                  class="form-control"
                  :raw="false"
                  :options="options.phone"
                  placeholder="Telefon (Kişisel)"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form-group label="İşe Başlama Tarihi">
              <b-form-datepicker
                id="example-i18n-picker"
                v-model="formData.started"
                v-bind="{labelNoDateSelected: 'Tarih Seçiniz',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
                locale="tr"
                start-weekday="1"
                class="mb-1"
                :max="today"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Sözleşme Türü">
              <v-select
                v-model="contract"
                :options="contracts"
                label="title"
                :reduce="contract => contract.id"
                placeholder="Sözleşme Türü"
              />
            </b-form-group>
          </b-col>
          <b-col v-if="contract">
            <b-form-group label="Sözleşme Bitiş Tarihi">
              <b-form-datepicker
                id="contracted"
                v-model="formData.contracted"
                v-bind="{labelNoDateSelected: 'Tarih Seçiniz',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
                locale="tr"
                start-weekday="1"
                class="mb-1"
                :min="today"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
      <b-card>
        <b-card-title>Kariyer</b-card-title>
        <b-row>
          <b-col
            xs="12"
            md="6"
          >
            <b-form-group label="Departman">
              <v-select
                v-model="formData.employee_position.id_departments"
                :options="departmentsList"
                label="title"
                :reduce="departments => departments.id"
                placeholder="Departman Seçiniz"
              />
            </b-form-group>
          </b-col>
          <b-col
            xs="12"
            md="6"
          >
            <b-form-group label="Görev">
              <v-select
                v-model="formData.employee_position.id_employee_tasks"
                :options="employeeTasksList"
                label="title"
                :reduce="employee_tasks => employee_tasks.id"
                placeholder="Görev Seçiniz"
              />
            </b-form-group>
          </b-col>
          <b-col
            xs="12"
            md="6"
          >
            <b-form-group label="Yönetici">
              <v-select
                v-model="formData.employee_position.id_manager_employees"
                :options="employees"
                :reduce="employee => employee.id"
                label="title"
                placeholder="Seçiniz"
              />
            </b-form-group>
          </b-col>
          <b-col
            xs="12"
            md="6"
          >
            <b-form-group label="Görev Başlangıç">
              <b-form-datepicker
                id="position_started"
                v-model="formData.employee_position.started"
                v-bind="{labelNoDateSelected: 'Tarih Seçiniz',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
                locale="tr"
                start-weekday="1"
                class="mb-1"
                :max="today"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
      <b-card>
        <b-card-title>Kişisel Bilgiler</b-card-title>
        <b-row>
          <b-col>
            <b-form-group label="Uyruk">
              <b-form-input
                v-model="formData.employee_personal.nationality"
                placeholder="Uyruk"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Kimlik No">
              <cleave
                id="id"
                v-model="formData.employee_personal.idno"
                class="form-control"
                :raw="false"
                :options="options.block"
                placeholder="Kimlik No"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Doğum Tarihi">
              <cleave
                id="date"
                v-model="formData.employee_personal.birthday"
                class="form-control"
                :raw="false"
                :options="options.date"
                placeholder="GG.AA.YYYY"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Çocuk Sayısı">
              <cleave
                id="childrens"
                v-model="formData.employee_personal.childrens"
                class="form-control"
                :raw="false"
                :options="options.number"
                placeholder="Çocuk Sayısı"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Kan Grubu">
              <v-select
                v-model="formData.employee_personal.id_blood_group"
                :options="bloodGroups"
                label="title"
                :reduce="bloodGroup => bloodGroup.id"
                placeholder="Kan Grubu Seçiniz"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Medeni Durum">
              <v-select
                v-model="formData.employee_personal.id_maritals"
                :options="maritals"
                label="title"
                :reduce="marital => marital.id"
                placeholder="Medeni Durum Seçiniz"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            xs="12"
            md="6"
          >
            <b-form-group label="Eğitim Durumu">
              <v-select
                v-model="formData.employee_personal.id_educational_statuses"
                :options="educationalStatuses"
                label="title"
                :reduce="educationalStatus => educationalStatus.id"
                placeholder="Eğitim Durumu Seçiniz"
              />
            </b-form-group>
          </b-col>
          <b-col
            xs="12"
            md="6"
          >
            <b-form-group label="Eğitim Seviyesi">
              <v-select
                v-model="formData.employee_personal.id_education_levels"
                :options="educationalLevels"
                label="title"
                :reduce="educationalLevel => educationalLevel.id"
                placeholder="Eğitim Seviyesi Seçiniz"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Cinsiyet">
              <v-select
                v-model="formData.employee_personal.id_genders"
                :options="genders"
                label="title"
                :reduce="gender => gender.id"
                placeholder="Cinsiyet"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Engel Durumu">
              <v-select
                v-model="formData.employee_personal.id_disabilities"
                :options="disabilities"
                label="title"
                :reduce="disability => disability.id"
                placeholder="Engel Durumu Seçiniz"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
      <b-card>
        <b-card-title>İletişim Bilgileri</b-card-title>
        <b-row>
          <b-col>
            <b-form-group label="İl">
              <v-select
                v-model="formData.employee_contact.id_cities"
                :options="citiesList"
                label="title"
                :reduce="cities => cities.id"
                placeholder="İl Seçiniz"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="İlçe">
              <v-select
                v-model="formData.employee_contact.id_districts"
                :options="districtsList"
                label="title"
                :reduce="districts => districts.id"
                placeholder="İlçe Seçiniz"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Adres">
              <b-form-textarea
                v-model="formData.employee_contact.address"
                placeholder="Adres"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Acil Durumda Aranacak Kişi">
              <b-form-input
                v-model="formData.employee_contact.emergency_name"
                placeholder="Adı Soyadı"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Yakınlık Derecesi">
              <b-form-input
                v-model="formData.employee_contact.emergency_desc"
                placeholder="Yakınlık Derecesi"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Telefonu">
              <b-input-group>
                <b-input-group-prepend is-text>
                  TR (+90)
                </b-input-group-prepend>
                <cleave
                  id="emergency_phone"
                  v-model="formData.employee_contact.emergency_phone"
                  class="form-control"
                  :raw="false"
                  :options="options.phone"
                  placeholder="Telefonu"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
      <b-card>
        <b-card-title>Banka Hesap Bilgileri</b-card-title>
        <b-row>
          <b-col>
            <b-form-group label="Banka">
              <v-select
                v-model="formData.employee_bank.id_banks"
                :options="banks"
                :reduce="bank => bank.id"
                label="title"
                placeholder="Banka Seçiniz"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Iban No">
              <cleave
                id="iban"
                v-model="formData.employee_bank.iban"
                class="form-control"
                :raw="false"
                :options="options.iban"
                placeholder="Iban No Giriniz"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
    <b-col
      xs="12"
      md="4"
    >
      <b-card class="text-center">
        <b-card-title>Personel Kartı</b-card-title>
        <b-avatar
          v-if="formData.name && formData.surname"
          size="150px"
          variant="secondary"
          :text="formData.name.charAt(0)+formData.surname.charAt(0)"
        />
        <div
          v-if="formData.name"
          class="mt-2"
        >
          <div class="font-medium-4 font-weight-bolder">
            {{ formData.name }} {{ formData.surname }}
          </div>
          <hr>
        </div>
        <div
          v-if="formData.started"
          class="mt-2"
        >
          <div class="font-weight-bold">
            İşe Başlama Tarihi
          </div>
          <div>{{ this.moment(formData.started).format('DD.MM.YYYY') }}</div>
        </div>
        <div
          v-if="formData.email_business"
          class="mt-2"
        >
          <div class="font-weight-bold">
            E-Posta (İş)
          </div>
          <div>{{ formData.email_business }}</div>
        </div>
        <div
          v-if="formData.phone_business"
          class="mt-2"
        >
          <div class="font-weight-bold">
            Telefon (İş)
          </div>
          <div>{{ formData.phone_business }}</div>
        </div>
        <b-button
          v-if="formData.name && formData.surname && formData.started"
          variant="primary"
          class="mt-2"
          @click="submitForm"
        >
          Kaydet
        </b-button>
      </b-card>
    </b-col>
    {{ saveStatus }}
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BCardTitle, BFormGroup, BFormInput, BFormTextarea, BAvatar, BFormDatepicker, BInputGroup, BInputGroupPrepend, BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Cleave from 'vue-cleave-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.tr'

export default {
  name: 'Add',
  components: {
    BRow,
    BCol,
    BCard,
    BCardTitle,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BAvatar,
    BFormDatepicker,
    vSelect,
    Cleave,
    BInputGroup,
    BInputGroupPrepend,
    BButton,
  },
  data() {
    return {
      submitStatus: false,
      today: this.moment().format('YYYY-MM-DD'),
      options: {
        phone: {
          phone: true,
          phoneRegionCode: 'TR',
        },
        date: {
          date: true,
          delimiter: '.',
          datePattern: ['d', 'm', 'Y'],
        },
        block: {
          blocks: [11],
        },
        iban: {
          blocks: [4, 4, 4, 4, 4, 4, 2],
          uppercase: true,
        },
        number: {
          numeral: true,
          numeralThousandsGroupStyle: 'hundreds',
        },
      },
      contracts: [
        {
          id: 0,
          title: 'Süresiz',
        },
        {
          id: 1,
          title: 'Süreli',
        },
      ],
      contract: null,
      formData: {
        /* Table: employees -> Ana Tablo */
        name: null,
        surname: null,
        email_business: null,
        email_personal: null,
        phone_business: null,
        phone_personal: null,
        contracted: null,
        started: null,
        /* Table: employee_position -> Kariyer Bilgisi */
        employee_position: {
          started: null,
          ended: null,
          id_departments: null,
          id_employee_tasks: null,
          id_manager_employees: null,
        },
        /* Table: employee_personal -> Kişisel Bilgiler */
        employee_personal: {
          idno: null,
          birthday: null,
          nationality: null,
          childrens: null,
          id_maritals: null,
          id_genders: null,
          id_disabilities: null,
          id_blood_group: null,
          id_educational_statuses: null,
          id_education_levels: null,
        },
        /* Table: employee_bank -> Diğer Bilgiler */
        employee_bank: {
          iban: null,
          id_banks: null,
        },
        /* Table: employee_contact -> iletişim bilgileri */
        employee_contact: {
          address: null,
          phone: null,
          emergency_name: null,
          emergency_desc: null,
          emergency_phone: null,
          id_cities: null,
          id_districts: null,
        },
      },
    }
  },
  computed: {
    departmentsList() {
      return this.$store.getters['departments/getDepartments']
    },
    employeeTasksList() {
      return this.$store.getters['employeeTasks/getEmployeeTasks']
    },
    citiesList() {
      return this.$store.getters['cities/getCities']
    },
    districtsList() {
      return this.$store.getters['districts/getDistricts']
    },
    bloodGroups() {
      return this.$store.getters['bloodGroup/getBloodGroups']
    },
    maritals() {
      return this.$store.getters['maritals/getMaritals']
    },
    educationalStatuses() {
      return this.$store.getters['educationalStatuses/getEducationalStatuses']
    },
    educationalLevels() {
      return this.$store.getters['educationLevels/getEducationLevels']
    },
    disabilities() {
      return this.$store.getters['disabilities/getDisabilities']
    },
    banks() {
      return this.$store.getters['banks/getBanks']
    },
    genders() {
      return this.$store.getters['genders/getGenders']
    },
    employees() {
      return this.$store.getters['employees/getEmployees']
    },
    saveStatus() {
      return this.$store.getters['employees/getEmployeeSaveStatus']
    },
  },
  watch: {
    saveStatus(val) {
      if (val.status === true) {
        this.formData = {
          /* Table: employees -> Ana Tablo */
          name: null,
          surname: null,
          email_business: null,
          email_personal: null,
          phone_business: null,
          phone_personal: null,
          contracted: null,
          started: null,
          /* Table: employee_position -> Kariyer Bilgisi */
          employee_position: {
            started: null,
            ended: null,
            id_departments: null,
            id_employee_tasks: null,
            id_manager_employees: null,
          },
          /* Table: employee_personal -> Kişisel Bilgiler */
          employee_personal: {
            idno: null,
            birthday: null,
            nationality: null,
            childrens: null,
            id_maritals: null,
            id_genders: null,
            id_disabilities: null,
            id_blood_group: null,
            id_educational_statuses: null,
            id_education_levels: null,
          },
          /* Table: employee_bank -> Diğer Bilgiler */
          employee_bank: {
            iban: null,
            id_banks: null,
          },
          /* Table: employee_contact -> iletişim bilgileri */
          employee_contact: {
            address: null,
            phone: null,
            emergency_name: null,
            emergency_desc: null,
            emergency_phone: null,
            id_cities: null,
            id_districts: null,
          },
        }
        const config = {
          icon: 'success',
          title: 'İşlem Başarılı!',
          text: 'Kayıt işleminiz başarılı!',
          html: null,
          buttonText: 'Kapat',
        }
        this.sweetAlert(config)
      } else if (val.status === false) {
        const config = {
          icon: 'error',
          title: 'İşlem Hatası!',
          text: 'Kayıt işleminiz yapılamadı.! Lütfen tekrar deneyiniz.',
          html: null,
          buttonText: 'Kapat',
        }
        this.sweetAlert(config)
      }
      this.submitStatus = false
    },
  },
  created() {
    this.getDepartments()
    this.getEmployeeTasks()
    this.getCities()
    this.getDistricts()
    this.getEmployees()
    this.getBloodGroups()
    this.getEducationalStatus()
    this.getEducationLevels()
    this.getDisabilities()
    this.getMaritals()
    this.getGenders()
    this.getBanks()
  },
  methods: {
    getDepartments() {
      this.$store.dispatch('departments/departmentsList')
    },
    getEmployeeTasks() {
      this.$store.dispatch('employeeTasks/employeeTasksList')
    },
    getCities() {
      this.$store.dispatch('cities/citiesList')
    },
    getDistricts() {
      this.$store.dispatch('districts/districtsList')
    },
    getBloodGroups() {
      this.$store.dispatch('bloodGroup/bloodGroupsList')
    },
    getMaritals() {
      this.$store.dispatch('maritals/maritalsList')
    },
    getEducationalStatus() {
      this.$store.dispatch('educationalStatuses/educationalStatusesList')
    },
    getEducationLevels() {
      this.$store.dispatch('educationLevels/educationLevelsList')
    },
    getDisabilities() {
      this.$store.dispatch('disabilities/disabilitiesList')
    },
    getBanks() {
      this.$store.dispatch('banks/banksList')
    },
    getGenders() {
      this.$store.dispatch('genders/gendersList')
    },
    getEmployees() {
      this.$store.dispatch('employees/employeesList', {
        select: [
          'employees.id AS id',
          'concat(employees.name, " " ,employees.surname) AS title',
        ],
        where: {
          'employees.ended': null,
        },
      })
    },
    sweetAlert(config) {
      this.$swal({
        icon: config.icon,
        title: config.title,
        text: config.text,
        html: config.html,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        confirmButtonText: config.buttonText,
        buttonsStyling: false,
      })
    },
    submitForm() {
      this.submitStatus = true
      this.$store.dispatch('employees/employeeSave', this.formData)
    },
  },
}
</script>

<style scoped></style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
